<template>
	<div>
		<v-row class="mt-sm-3 body-transaction-product body-transaction-product-sm">
			<v-col cols="12" class="pt-0">
				<template>
					<div class="px-3 d-none d-sm-flex flex-wrap">
						<v-col sm="2" md="1" class="py-0"></v-col>
						<v-col sm="5" md="8" class="pl-md-5 py-0">
							<div class="font-size-11 font-weight-bold">Item</div>
						</v-col>
						<v-col sm="2" md="1" class="py-0 text-sm-center">
							<div class="font-size-11 font-weight-bold">Qty</div>
						</v-col>
						<v-col sm="3" md="2" class="py-0 text-sm-right">
							<div class="font-size-11 font-weight-bold">Total</div>
						</v-col>
					</div>
					<v-card class="mt-3 pa-3 elevation-0 rounded-xl hover-shadow" v-for="product in firstData" :key="product.product_id">
						<div class="d-flex flex-wrap">
							<v-col cols="3" sm="2" md="1" class="py-0 px-0">
								<v-img contain width="75px" height="75px" class="rounded-xl" :src="product.product_image ? product.product_image : '/assets/image/user-pict.jpg'"></v-img>
							</v-col>
							<v-col cols="12" sm="5" md="8" class="pl-sm-0 pl-md-5 py-0 my-auto">
								<div class="cl-dark-green font-size-xs-10 font-size-11">{{ product.product_name }}</div>
								<div class="secondary--text font-size-xs-10 font-size-11">
									{{ product.product_price | toRupiah }}
								</div>
							</v-col>
							<v-col cols="3" sm="2" md="1" class="pb-0 py-sm-0 my-auto text-sm-center">
								<div class="cl-dark-green font-size-xs-10 font-size-11 font-weight-bold">
									<span class="font-weight-bold d-sm-none">x</span>
									{{ parseInt(product.product_quantity) }}
								</div>
							</v-col>
							<v-col cols="6" sm="3" md="2" class="pb-0 py-sm-0 my-auto text-right">
								<div class="cl-dark-green font-size-xs-10 font-size-11 font-weight-bold">{{ product.product_total | toRupiah }}</div>
							</v-col>
						</div>
					</v-card>
				</template>
				<template>
					<div class="mt-3 d-flex flex-wrap justify-end">
						<v-col md="6" class="pa-0">
							<v-card class="pa-3 elevation-0 rounded-xl hover-shadow">
								<div class="pa-3">
									<div class="d-flex flex-wrap justify-space-between">
										<div class="cl-dark-green font-size-xs-10 font-size-11">Total Harga</div>
										<div class="cl-dark-green font-size-xs-10 font-size-11 font-weight-bold">{{ sumTotal | toRupiah }}</div>
									</div>
								</div>
							</v-card>
						</v-col>
					</div>
				</template>
			</v-col>
		</v-row>
		<div class="footer-transaction-product rounded-xl">
			<div class="d-flex flex-wrap">
				<v-col cols="12" class="pb-0 px-0 pa-sm-0 text-right my-auto">
					<v-btn large width="130" depressed color="grey lighten-3" class="rounded-pill" @click="nextStep('back')">
						<v-icon>mdi-arrow-left</v-icon>
						<span class="pl-2 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">Kembali</span>
					</v-btn>
					<v-btn large width="120" depressed color="primary" class="ml-2 rounded-pill" :disabled="btnDisabled" @click="showModalConfirm">
						<span class="pr-2 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">Proses</span>
						<v-icon>mdi-checkbox-marked-circle-outline</v-icon>
					</v-btn>
				</v-col>
			</div>
		</div>
		<ModalConfirm ref="modalConfirm" :msg="msgConfirm" @action="processTransaction"></ModalConfirm>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import ModalConfirm from '@/components/modals/vo-general/ModalKonfirmasi';

export default {
	components: {
		ModalConfirm
	},
	data() {
		return {
			btnDisabled: false,
			address_data: {},
			courier_data: {},
			secondData: {
				transaction_product_code: [],
				transaction_product_qty: [],
			},
			msgConfirm: 'Apakah Anda yakin untuk memproses transaksi?',
		}
	},
	props: {
		firstData: Array,
	},
	computed: {
		sumTotal() {
			let total = 0
			this.firstData.forEach((el) => {
				total += parseInt(el.product_total)
			})
			return total
		},
	},
	methods: {
		...mapActions('transaksiProduk', ['addTransaction']),

		resetData() {
			this.secondData.transaction_product_code = []
			this.secondData.transaction_product_qty = []
		},
		nextStep(step) {
			if (step == 'back') {
				this.$emit('action', step)
			} else if (step == 'next') {
				this.$emit('action', step)
			}
		},
		showModalConfirm() {
			this.$refs.modalConfirm.modalShow()
		},
		processTransaction() {
			this.$refs.modalConfirm.loadingButton()

			/* fill secondData */
			this.firstData.forEach((el) => {
				this.secondData.transaction_product_code.push(el.product_code)
				this.secondData.transaction_product_qty.push(el.product_quantity)
			})

			this.addTransaction(this.secondData).then(()=> {
				this.$refs.modalConfirm.modalHide()
				this.$refs.modalConfirm.normalButton()
				this.nextStep('next')
			}).catch(()=> {
				this.$refs.modalConfirm.normalButton()
			})
		},
	},
	created() {
	},
};
</script>